<div class="login-container">
  <div class="login-box">
    <div class="text-center mb-4">
      <i class="bi bi-shield-lock-fill fs-1 text-primary"></i>
      <h4 class="mt-3">Two-Factor Authentication</h4>
      <p class="text-muted">Enter the 6-digit code from your authenticator app</p>
    </div>

    <form>
      <div class="mb-3">
        <label for="otp" class="form-label">Verification Code</label>
        <input
          type="text"
          id="otp"
          class="form-control"
          [(ngModel)]="otp"
          name="otp"
          (input)="onOtpInput($event)"
          placeholder="123456"
          maxlength="6"
          autocomplete="off"
          autofocus>
      </div>

      @if (errorMessage) {
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      }

      <div class="d-grid gap-2">
        <button
          type="button"
          class="btn btn-primary"
          (click)="verify()"
          [disabled]="!otp || otp.length < 6 || isLoading">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm me-2"></span>
          }
          Verify
        </button>
        <button type="button" class="btn btn-link" (click)="onLogout()">
          Logout
        </button>
      </div>
    </form>
  </div>
</div>